var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1757_5228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 10.3511L7.27875 9.37988L6.75 9.90863L8.25 11.4086L11.25 8.40863L10.7213 7.87988L8.25 10.3511Z",
    fill: "#FFD233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37109 2.03345H8.24609V1.65845C8.2455 1.45972 8.16629 1.2693 8.02577 1.12877C7.88524 0.988249 7.69482 0.909041 7.49609 0.908447H4.49609C4.29736 0.909041 4.10694 0.988249 3.96642 1.12877C3.8259 1.2693 3.74669 1.45972 3.74609 1.65845V2.03345H2.62109C2.42236 2.03404 2.23194 2.11325 2.09142 2.25377C1.9509 2.3943 1.87169 2.58472 1.87109 2.78345V10.6584C1.87169 10.8572 1.9509 11.0476 2.09142 11.1881C2.23194 11.3286 2.42236 11.4079 2.62109 11.4084H5.99609V10.6584H2.62109V2.78345H3.74609V3.90845H8.24609V2.78345H9.37109V6.90845H10.1211V2.78345C10.1205 2.58472 10.0413 2.3943 9.90077 2.25377C9.76024 2.11325 9.56982 2.03404 9.37109 2.03345ZM7.49609 3.15845H4.49609V1.65845H7.49609V3.15845Z",
    fill: "#FFD233"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1757_5228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.158569)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.e87392ed32348f143389b94a53dacc8a.svg";
export { ForwardRef as ReactComponent };